import { render } from "./branchDetails.vue?vue&type=template&id=4e5a3d85&scoped=true"
import script from "./branchDetails.vue?vue&type=script&lang=js"
export * from "./branchDetails.vue?vue&type=script&lang=js"

import "./branchDetails.vue?vue&type=style&index=0&id=4e5a3d85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5a3d85"]])

export default __exports__